import Vue from 'vue';
import VueFontAwesomePicker from 'vfa-picker';

Vue.use(VueFontAwesomePicker);